import { render, staticRenderFns } from "./UploadTaskView.vue?vue&type=template&id=9b563c18&"
import script from "./UploadTaskView.vue?vue&type=script&lang=js&"
export * from "./UploadTaskView.vue?vue&type=script&lang=js&"
import style0 from "./UploadTaskView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports